import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=6bb24275&"
import script from "./LogoutDialog.vue?vue&type=script&lang=js&"
export * from "./LogoutDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports